import { createFileRoute, redirect } from "@tanstack/react-router";

/** The team is the employee register, which is HR's front door. */
export const Route = createFileRoute("/_authenticated/_workforce/hr/team")({
  beforeLoad: () => {
    throw redirect({ to: "/hr" });
  },
});
